import { useContext, useEffect, useState } from "react";
import { getAddressesAndQuestions } from "../Account/utils/requestsTS";
import { CheckoutContext } from "../Checkout/CheckoutContext";
import { initDeliveryAddressState, refetchAddresses } from "./addressesUtils";
import { useBillingInformation } from "../Account/BillingInformation/Shared/hooks/useBillingInformation/useBillingInformation";
export const useAddresses = (orderId, programId, programSKU, subscriptionLinkId) => {
    // * Though we do not need anything that is returned from the billing information hook, we still need to call it to update the billing information context.
    useBillingInformation();
    const [addressState, setAddressState] = useState(initDeliveryAddressState);
    const { setCustomerShippingAddresses } = useContext(CheckoutContext);
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            getAddressesAndQuestions(setAddressState, programId, programSKU, orderId, initDeliveryAddressState, setCustomerShippingAddresses, subscriptionLinkId);
        }
        return () => {
            mounted = false;
        };
    }, []);
    return {
        addressState,
        refetchAddresses: refetchAddresses(setAddressState, programId, programSKU, orderId, initDeliveryAddressState, setCustomerShippingAddresses, subscriptionLinkId),
    };
};
